<script setup lang="ts">
import type { CheckoutResponse } from "#shared/types/core/ecommerce/checkout";
import { KsDialog } from "@aschehoug/kloss";

const props = defineProps<{ data: CheckoutResponse | undefined }>();

const emit = defineEmits(["close"]);

const auth = useAuthorizeStore();

// TODO: Poll session status?
const iframeContainer = useTemplateRef("iframe-container");

function handleVippsDialogClose() {
  emit("close");
  // TODO: If possible, we should cancel the checkout session here, but AFAICT, the Vipps API doesn't support this.
  if (iframeContainer.value) {
    iframeContainer.value.innerHTML = "";
  }
}

const isConsumer = computed(() => auth.isConsumer);

const vipps = useVippsCheckout(isConsumer);

watch([iframeContainer, () => props.data], ([el, checkoutRes]) => {
  if (el && checkoutRes) {
    vipps.checkout(checkoutRes);
  }
});
</script>

<template>
  <KsDialog
    v-if="isConsumer"
    title="Fullfør kjøp"
    :open="data !== undefined"
    @close="handleVippsDialogClose"
  >
    <template #body>
      <section :id="VIPPS_IFRAME_CONTAINER_ID" ref="iframe-container" />
    </template>
  </KsDialog>
</template>
